import { graphql } from '@/graphql-setup'

export const USER_DOCUMENT_RENEWAL_REMINDER_QUERY = graphql(`
  query UserDocumentRenewalReminder($user: ID, $responsibleUser: ID) {
    allUserDocuments(
      user: $user
      responsibleUser: $responsibleUser
      orderBy: "expirationDate"
    ) {
      edges {
        node {
          id
          name
          expirationDate
          notificationTime
          user {
            id
            fullName
          }
        }
      }
    }
  }
`)
